var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_271_1406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 7.71427V12M12.0001 15.8571V16.2857M3.62522 19.4448C7.47293 23.9631 16.5277 23.9631 20.3755 19.4448C23.9194 15.283 23.6504 7.1371 19.3849 3.5741C15.5641 0.38269 8.4365 0.38269 4.61577 3.5741C0.350202 7.1371 0.0812228 15.283 3.62522 19.4448Z",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_271_1406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "currentColor"
  })))));
};

export { SvgWarning as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8yNzFfMTQwNikiPgogICAgICAgIDxwYXRoIGQ9Ik0xMi4wMDAxIDcuNzE0MjdWMTJNMTIuMDAwMSAxNS44NTcxVjE2LjI4NTdNMy42MjUyMiAxOS40NDQ4QzcuNDcyOTMgMjMuOTYzMSAxNi41Mjc3IDIzLjk2MzEgMjAuMzc1NSAxOS40NDQ4QzIzLjkxOTQgMTUuMjgzIDIzLjY1MDQgNy4xMzcxIDE5LjM4NDkgMy41NzQxQzE1LjU2NDEgMC4zODI2OSA4LjQzNjUgMC4zODI2OSA0LjYxNTc3IDMuNTc0MUMwLjM1MDIwMiA3LjEzNzEgMC4wODEyMjI4IDE1LjI4MyAzLjYyNTIyIDE5LjQ0NDhaIgogICAgICAgICAgICAgIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuNzE0MjkiIHZlY3Rvci1lZmZlY3Q9Im5vbi1zY2FsaW5nLXN0cm9rZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogICAgICAgICAgICAgIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KICAgIDwvZz4KICAgIDxkZWZzPgogICAgICAgIDxjbGlwUGF0aCBpZD0iY2xpcDBfMjcxXzE0MDYiPgogICAgICAgICAgICA8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgogICAgICAgIDwvY2xpcFBhdGg+CiAgICA8L2RlZnM+Cjwvc3ZnPgo=";